import { toFormData } from "../utils/toFormData";
import { doPostRequest } from "./mainAPI";
import { EXPORT } from "../constants/mainAPI";
import { ExportFileDataCreate, ExportFileSuccessResponse } from "../types/api/export";

export const createExportFile = (
    data: ExportFileDataCreate,
    callback?: (resp: ExportFileSuccessResponse) => void,
    errorCallback?: (resp: any) => void,
) => {
    const formData = toFormData(data);

    return doPostRequest(EXPORT, true, formData, {}, callback, errorCallback);
};
